import { Fragment } from 'react';
import { modKeyLabel } from '@/lib/hooks';
import { STAFF_SHORTCUTS } from '@/lib/nav/staff';
import { Kbd } from '@/components/ui/misc';
import { Modal } from '@/components/ui/Dialog';

function Keys({ spec }: { spec: string }) {
  if (spec.includes('+') && spec.split('+').length > 1 && !spec.includes(' ')) {
    const parts = spec.split('+');
    return (
      <span className="flex items-center gap-1">
        {parts.map((p, i) => (
          <Kbd key={i}>{p.toLowerCase() === 'mod' ? modKeyLabel() : p.length === 1 ? p.toUpperCase() : p}</Kbd>
        ))}
      </span>
    );
  }
  const seq = spec.split(' ');
  const isSequence = seq.length === 2 && spec.length <= 3;
  return (
    <span className="flex items-center gap-1">
      {seq.map((p, i) =>
        p === '/' || p === '+' ? (
          <span key={i} className="text-2xs text-ink-subtle">
            {p === '/' ? 'or' : 'plus'}
          </span>
        ) : (
          <Fragment key={i}>
            {i > 0 && isSequence && <span className="text-2xs text-ink-subtle">then</span>}
            <Kbd>{p.length === 1 ? p.toUpperCase() : p}</Kbd>
          </Fragment>
        ),
      )}
    </span>
  );
}

/** The `?` cheat sheet. Groups come from STAFF_SHORTCUTS in the nav config. */
export function ShortcutSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const groups = Array.from(new Set(STAFF_SHORTCUTS.map((s) => s.group)));
  return (
    <Modal open={open} onClose={onClose} title="Keyboard shortcuts" description="Work faster without leaving the keyboard." size="md">
      <div className="space-y-6">
        {groups.map((group) => (
          <section key={group} aria-labelledby={`sc-${group}`}>
            <h3 id={`sc-${group}`} className="mb-2 text-2xs font-semibold uppercase tracking-wider text-ink-subtle">
              {group}
            </h3>
            <dl className="divide-y divide-line">
              {STAFF_SHORTCUTS.filter((s) => s.group === group).map((s) => (
                <div key={`${s.keys}-${s.label}`} className="flex items-center justify-between gap-4 py-2">
                  <dt className="text-sm text-ink">{s.label}</dt>
                  <dd>
                    <Keys spec={s.keys} />
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Modal>
  );
}
